import chasseursReducer from "../chasseursReducer";
import partenairesAcademiquesReducer from "../partenairesAcademiquesReducer";
import etablissementsReducer from "../etablissementsReducer";
import candidatsReducer from "../candidatsReducer";
import demandesRecrutementReducer from "../demandesRecrutementReducer";
import evaluationReducer from "../evaluationReducer";
import candidaturesReducer from "../candidaturesReducer";
import entretiensReducer from "../entretiensReducer";
import offresSalarialesReducer from "../offresSalarialesReducer";
import demandeCandidatSauvegardeReducer from "../demandeCandidatSauvegardeReducer";
import competencesGeneriquesReducer from "../competencesGeneriquesReducer";
import offresEmploiReducer from "../offresEmploiReducer";
import preEmbaucheReducer from "../preEmbaucheReducer";

const recrutementReducers = {
  chasseurs: chasseursReducer,
  partenairesAcademiques: partenairesAcademiquesReducer,
  etablissements: etablissementsReducer,
  candidats: candidatsReducer,
  demandesRecrutement: demandesRecrutementReducer,
   competencesGeneriques:competencesGeneriquesReducer,
    offresEmploi: offresEmploiReducer,
  evaluations: evaluationReducer,
  candidatures: candidaturesReducer,
  preEmbauche: preEmbaucheReducer,
  entretiens: entretiensReducer,
  offresSalariales: offresSalarialesReducer,
  demandeCandidatSauvegarde: demandeCandidatSauvegardeReducer,
};

export default recrutementReducers;
